export default __webpack_public_path__ + "static/zach-08dac13b5a1611acea75721e8c3c4224.jpeg";